/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

// This global state is used to store the 'Master Data' and 'Default Confiqurations'

const state = {
  // Theme default confiqurations
  theme: 'light',
  repoUrl: '',
  filterDatas: {
    brand: '',
    category: '',
    supplier: '',
    status: '',
    customer: '',
    biller: '',
    product: '',
    saleType: '',
    customerType: '',
    customerTypequery: '',
    productquery: '',
    warehouse: '',
    warehousequery: '',
    purchasestatus: '',
    purchaseOrderstatus: '',
    paymentStatus: '',
    amount: '',
    transferStatus: '',
    paymenType: '',
    type: '',
    cheqStatus: '',
    cheqFor: '',
    expnseCategoryquery: '',
    brandquery: '',
    categoryquery: '',
    supplierquery: '',
    shopquery: '',
    customerquery: '',
    billerquery: '',
    expenseCategory: '',
    start: '',
    end: '',
    search: '',
    shop: '',
    toShop: '',
    fromShop: '',
    isrouteNewPage: true,
    isrouteNewTab: true,
    isRemoveDatecaeche: true,
  },
  productpagesize: 1,
  productperpageItemsize: 15,
  // Master Data
  countries: '',
  currentCalculation: 0,
  event: [],
  chequeDetails: {},

  calculatorVisible: false,
  ShopView: 'name',
  WarehouseView: 'name',
  imagelink: null,
  server_messages: [],
  StoreDatas: [],
  Columnheaders: [],
  StockTransferWarehouse: '',
  StockTransferWarehouseQuery: '',
  iSPdfShow: false,
  LoadingBar: false,
  saleQuotation: false,
  modulename: 'name',
  purchaseTotal: 0,
  discountTotal: 0,
  purchasePaid: 0,
  saleDetails: '',
  salesTotal: 0,
  salesNet: 0,
  salesDiscount: 0,
  BulkEdit: [],
  keyShortcuts: {},
  SelectedDatas: [],
  //pos url
  pos_url: '',
  totalSalesAmount: null,
  PaymentDatas: [
    {
      payment_type: 'Cash',
      payment_note: '',
      amount: '',
    },
  ],
  StoredProducts: [
    {
      productid: '',
      batches: '',
      available_Stocks: '',
      ProductVisible: true,
      validateUnit: false,
      selectedProdct: {},
      selectedBatch: {},
      selectedUnit: {},
      units: '',
      batch_id: '',
      unit_id: '',
      amount: 0,
      discount: 0,
      quantity: 0,
    },
  ],
  //pos url
  // pos_url: "",
  // For Filters
  dateformat: 'DD-MMM-YYYY',
  timeformat: 'DD-MMM-YYYY HH:mm:ss',
  monthyearformat: 'MMMM YYYY',
  yearonlyformat: 'YYYY',

  // Pagination Settings
  pagination_settings: {},
  // BreadCrumb
  breadcrumb: '',
};

export default state;
